import { App } from 'antd';
import { useCopyToClipboard } from 'react-use';

import { Button } from '@desygner/ui-common-components';
import { useTranslation } from '@desygner/ui-common-translation';

import { useResponsive } from '../../../../../../hooks/useResponsive';

export const SimpleShare = () => {
  const { message } = App.useApp();
  const { t } = useTranslation();
  const { isTabletOrMobile } = useResponsive();

  const [, copy] = useCopyToClipboard();

  async function handleCopyLinkToClipboard(link: string) {
    copy(link);
    message.success(t('tool.topbar.share_success_msg'));
  }

  function handleShare() {
    return () => {
      handleCopyLinkToClipboard(window.location.href);
    };
  }

  return (
    <Button
      action="share"
      title={isTabletOrMobile ? undefined : t('tool.topbar.share_tooltip')}
      variant="ghost"
      size="Small"
      icon={
        !isTabletOrMobile
          ? {
              name: 'share---triangle',
              size: 'Small',
            }
          : undefined
      }
      onClick={handleShare()}
      label={isTabletOrMobile ? t('tool.topbar.share_button') : undefined}
    />
  );
};
